const isHastElement = (node) => node.type === "element";
export {
  isHastElement
};
//# sourceMappingURL=types.js.map
